import styled, {css} from 'styled-components';

import MaybeButton from '../utils/MaybeButton';

interface Props {
  size?: string;
  fontSize?: string;
  round?: boolean;
  square?: boolean;
  fill?: boolean;
}

const BtnContainer = styled(MaybeButton)<Props>`
  --btn-size: ${({size}) =>
    size ? size : css`var(--btn-default-size, 2.5rem)`};
  --btn-radius: ${({round, square}) =>
    round
      ? css`var(--theme-circle-radius)`
      : square
        ? 'none'
        : css`var(--theme-radius)`};
  --icon-default-size: min(1.5rem, var(--btn-size) * 0.75);
  --btn-font-size: ${({fontSize}) =>
    fontSize
      ? fontSize
      : css`max(var(--btn-size) / 2 - 0.5rem, var(--theme-font-size-control))`};
  position: relative;
  min-width: var(--btn-size);
  cursor: pointer;

  ${({fill}) =>
    fill &&
    css`
      flex-grow: 1;
    `}
`;

export default BtnContainer;
